<template>
    <ui-card
        icon="fal fa-ballot-check"
        title="Campos de Pagamento"
        text="Informe os campos personalizados de pagamentos."
    >
        <template #body>
            <ui-load-success
                v-if="loader.overlay"
                :loading="loader.overlayLoading"
                :success="loader.overlaySucess"
            />

            <div class="area-card">
                <ui-payment-table v-model="table" :name="name" />
            </div>
        </template>

        <template #fl/>

        <template #fr>
            <ui-button design="md primary" :disabled="!canSubmit" @click="addPayment">
                Criar Campo
            </ui-button>
        </template>
    </ui-card>
</template>
<script>
	import { uiCard } from '@/components/ui/cards'
	import { uiButton } from '@/components/ui/buttons'
	import { uiLoadSuccess } from '@/components/ui/overlays'
	import { uiPaymentTable } from '@/components/ui-facilita/payment'

	const defaultForm = () => ({
		fields: {},
	})

	const defaultLoader = () => ({
		body: false,
		overlay: false,
		overlayLoading: true,
		overlaySucess: true,
	})

	export default {
		name: 'configuration-proposal-payment-fields',

		components: {
			uiCard,
			uiButton,
			uiLoadSuccess,
			uiPaymentTable
		},

		data() {
			return {
				form: { ...defaultForm() },
				name: 'payment-table',
				table: {},
				loader: { ...defaultLoader() },
				oldForm: {},
			}
		},

		computed: {
			canSubmit() {
				return !this.table.loader
			},
		},

		methods: {
			async addPayment() {
				this.$root.$emit(`modal-open-${this.name}-modal`)
			},
		},
	}
</script>

<style lang="stylus" scoped>
	@import './styles.styl'
</style>
